/**
 * 회원가입 약관 본문(전문). AgreementsStep 의 "보기" 모달에서 사용한다.
 *
 * terms/privacy 본문은 `features/legal` 의 LEGAL_DOCS 를 그대로 쓴다. 같은 txt 를
 * 두 곳에서 각자 import 하면 버전 개념이 붙을 자리가 없고, 한쪽만 교체됐을 때
 * 가입 화면과 약관 페이지가 다른 문서를 보여준다.
 *
 * marketing/event 는 수신 동의라 버전 관리 대상이 아니므로 txt 를 직접 읽는다.
 */
import { LEGAL_DOCS } from '@/features/legal';
import marketingRaw from '../legal/marketing.txt?raw';
import eventRaw from '../legal/event.txt?raw';

export type AgreementKey = 'terms' | 'privacy' | 'marketing' | 'event';

export interface AgreementDoc {
  title: string;
  /** 줄바꿈(\n) 기준 문단 — 모달에서 whitespace-pre-wrap 로 렌더 */
  content: string;
}

export const AGREEMENT_DOCS: Record<AgreementKey, AgreementDoc> = {
  // 제목은 동의 문맥에 맞춘다(문서 제목과 다를 수 있다). 본문만 공유한다.
  terms: { title: '이용약관', content: LEGAL_DOCS.terms.body },
  // 동의 시점 고지사항(목적·항목·보유기간·거부권)만 보여 준다 — 처리방침 전문은 동의 대상이 아니다.
  privacy: {
    title: '개인정보 수집 및 이용 동의',
    content: LEGAL_DOCS.privacy.consentNotice,
  },
  marketing: { title: '마케팅 정보 수신 동의', content: marketingRaw },
  event: { title: '이벤트 및 혜택 알림 수신 동의', content: eventRaw },
};
